(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pilpoil-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',(event)=>{
  const mobileLink=event.target.closest('.pp-mobile-mega a');
  if(mobileLink){
    const drawer=mobileLink.closest('.pp-nav-mobile');
    if(drawer) drawer.open=false;
  }
  const rootDetails=event.target.closest('.pp-mega-nav details');
  document.querySelectorAll('.pp-mega-nav details[open]').forEach((d)=>{
    if(rootDetails && d!==rootDetails && !d.contains(rootDetails)) d.open=false;
  });
});
document.addEventListener('keydown',(event)=>{
  if(event.key!=='Escape') return;
  document.querySelectorAll('.pp-mega-nav details[open],.pp-nav-mobile[open]').forEach((d)=>{d.open=false;});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pilpoil-pdp-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-pdp-video')) {
  customElements.define('pp-pdp-video', class extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      if (!button || this.bound) return;
      this.bound = true;
      button.addEventListener('click', () => {
        const fragment = this.querySelector('template').content.cloneNode(true);
        const video = fragment.querySelector('video');
        const image = button.querySelector('img');
        if (image) video.poster = image.currentSrc || image.src;
        video.setAttribute('aria-label', button.getAttribute('aria-label'));
        button.replaceWith(fragment);
        video.tabIndex = 0;
        video.focus({preventScroll:true});
        video.play().catch(() => {});
      }, {once:true});
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
